import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-latest-product-stock-info',
  templateUrl: './latest-product-stock-info.component.html',
  styleUrls: ['./latest-product-stock-info.component.css']
})
export class LatestProductStockInfoComponent implements OnInit {

  constructor(private fb: FormBuilder,private toastr: ToastrService,private generic_service: GenericService) { }

  stocks:any = []
  searchKey: any = ""
  pageNumber: number = 0;
  totalRecords: number = 0;
  recordsPerPage:number = 10;
  tableSize: number = 10;
  first: number = 0;
  isLoading: any = false

  actionControls: any = {
    isAdd: false, 
    isView: false, 
    isDelete: false, 
    isModify: false 
  }

  ngOnInit(): void {

    let href:any = window.location.href;
    let messages = href.split('/') 
    let action: any = this.generic_service.checkActionControls(messages[messages.length-1])
    this.actionControls = action

    this.getProductStock(this.pageNumber,this.recordsPerPage)
  }


  onTableDataChange(event: any) {
    this.pageNumber = event.page;
    console.log(event)

    if(this.searchKey == ""){
      this.getProductStock(this.pageNumber,this.recordsPerPage)
    }else{
      this.generic_service.getLatestProductStockInfoByProductName(this.searchKey,this.pageNumber,this.recordsPerPage).subscribe(
        (res:any)=>{
          console.log(res)
          this.totalRecords = res.response.totalRecords
          this.stocks = res.response.productStockInfoList
        },(error:any)=>{
          console.log(error)
        }
      )
    }
  }
 

  getProductStock(pageNumber:any,recordsPerPage:any){
    this.isLoading = true

    this.generic_service.getAllProductLatestBalance(pageNumber,recordsPerPage).subscribe(
      (res:any)=>{
        console.log(res)
        this.totalRecords = res.response.totalRecords
        this.stocks = res.response.productStockInfoList
      this.isLoading = false

      },(error:any)=>{
        console.log(error)
      }
    )
  }


  
  getLatestProductStockInfoByProductName(){
    this.pageNumber = 0;
    this.isLoading = true

    if(this.searchKey == ""){
      this.getProductStock(this.pageNumber,this.recordsPerPage)
      return
    }
    this.generic_service.getLatestProductStockInfoByProductName(this.searchKey,this.pageNumber,this.recordsPerPage).subscribe(
      (response:any)=>{
        console.log(response)
        this.stocks = response.response.productStockInfoList
        this.totalRecords = response.response.totalRecords;
        this.isLoading = false
      },(error:any)=>{
        console.log(error)
      }
    )
  }


  // searchKey: any = ""

  // getProductStockInfoByWildSearch(pageNumber: any,recordsPerPage: any){
  //   console.log(this.searchKey)
  //   if(this.searchKey != ""){
  //     this.isLoading = true

  //     this.generic_service.getProductStockInfoByWildSearch(this.searchKey,pageNumber,recordsPerPage).subscribe(
  //       (response:any)=>{
  //         console.log(response);
  //         this.stocks = response.response.productStockInfoList
  //         this.totalRecords = response.response.totalRecords;
  //         this.isLoading = false

  //       },
  //       (err:any)=>{
  //         console.log(err)
  //       }
  //     )
  //   }else{
  //     this.getProductStock(this.pageNumber,this.recordsPerPage)
  //   }
  // }

  refreshSearch(){
    this.searchKey = ""
    this.getProductStock(this.pageNumber,this.recordsPerPage)
  }


  refreshAll(){
    this.pageNumber = 0
    this.searchKey = ""
    this.getProductStock(this.pageNumber,this.recordsPerPage)
  }

  // getLatestProductStockInfoByProductName(pageNumber: any,recordsPerPage: any){
  //   console.log(this.searchKey)
  //   if(this.searchKey != ""){
  //     this.isLoading = true

  //     this.generic_service.getLatestProductStockInfoByProductName(this.searchKey,pageNumber,recordsPerPage).subscribe(
  //       (response:any)=>{
  //         console.log(response);
  //         this.stocks = response.response.productStockInfoList
  //         this.totalRecords = response.response.totalRecords;
  //         this.isLoading = false

  //       },
  //       (err:any)=>{
  //         console.log(err)
  //       }
  //     )
  //   }else{
  //     this.getProductStock(this.pageNumber,this.recordsPerPage)
  //   }
  // }

}
